import React from 'react';
import Banner from '../components/Banner';
import Services from '../components/Services';
import AboutUs  from './AboutUs';
import BrandCarousel from '../components/BrandCarousel';
const Home: React.FC = () => {
  return (
    <div>

      <Banner />
      <section>
      <AboutUs isDisplayShort={true} />
      <BrandCarousel />
      </section>
      {/* <Services /> */}
    </div>
  );
}

export default Home;
